export const Services = () => {
  return <h1 className="title">Services Page</h1>;
};
